import { useState, useEffect, useRef, forwardRef } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  InputGroup,
  Modal,
  Nav,
  Row,
  Tab,
  Table,
} from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import { Link, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../utils/checkNumberValidator";
import CheckNumberError from "../../../components/inputs/CheckNumberError";
import { customStyles } from "../../../assets/table-style";
import DataTable from "react-data-table-component";
// import { jwtDecode } from "jwt-decode";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { PaginationControls } from "../../../hooks/customHook/paginationHook/usePagination";
import { useServerPagination } from "../../../hooks/customHook/paginationHook/useServerPagination";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import {
  currencySymbol,
  formatCurrency,
  formatToTwoDecimal,
  parseNumber,
  truncateToTwoDecimals,
} from "../../../utils/numberFormatter";
import CustomDatePicker from "../../../components/CustomDatePicker";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import { checkCutoffDate } from "../../../utils/cutoffDateValidation";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";

const dropdownFilters = [
  { value: "all", label: "All" },
  { value: "transaction_id", label: "Transaction ID" },
  { value: "expensesCheque", label: "Cheque Number" },
  { value: "desc", label: "Remarks" },
  { value: "expenses_type", label: "Expenses Type" },
  { value: "expenses_date", label: "Expenses Date" },
  { value: "totalAmount", label: "Amount" },
];

// Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
// (TypedDateInput), or picked from the calendar. Only a complete date reaches
// handleDateChange, so the cutoff check doesn't run on a half-typed date.
const CustomInput = forwardRef(
  (
    {
      value,
      onClick,
      onChange,
      onBlur,
      onFocus,
      onKeyDown,
      generateYears,
      disabled,
    },
    ref,
  ) => {
    return (
      <TypedDateInput
        className="form-control p-2 w-100"
        style={{ cursor: disabled ? "not-allowed" : "text" }}
        onClick={(e) => {
          if (disabled) return; // Prevent clicking when disabled
          if (onClick) onClick(e);

          let selectedYear = new Date().getFullYear();
          if (value) {
            const parsed = new Date(value);
            // Extract year safely if value is a valid date
            if (!isNaN(parsed.getTime())) {
              selectedYear = parsed.getFullYear();
            }
          }

          // Reset/Initialize Year List based on selected date
          if (generateYears && typeof generateYears === "function") {
            generateYears(selectedYear);
          }
        }}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        value={value}
        ref={ref}
        required
        disabled={disabled}
      />
    );
  },
);

const LocalBulkExpenses = () => {
  const userLoggedID = useDecodeToken();

  // Cutoff warning for Process Date / Maturity Date (replaces
  // usePostedCutoffValidation). Warns when there's no cutoff yet or it's
  // already posted; a posted date is still cleared, same as before.
  // Skips partially typed years (e.g. "202") so it only fires on a full date.
  const warnCutoffDate = (selectedDate, clearDate, dateLabel) => {
    if (!selectedDate || new Date(selectedDate).getFullYear() < 1000) return;
    checkCutoffDate(selectedDate, dateLabel).then((status) => {
      if (status === "posted") clearDate("");
    });
  };

  // const [userLoggedID, setUserLoggedID] = useState("");
  // const decodeToken = () => {
  //   var token = localStorage.getItem("accessToken");
  //   if (typeof token === "string") {
  //     var decoded = jwtDecode(token);
  //     // console.log("DECODED TOKEN:", decoded);
  //     setUserLoggedID(decoded.id);
  //   }
  // };
  // useEffect(() => {
  //   decodeToken();
  // }, []);
  const navigate = useNavigate();
  const { foreign_url } = useParams();
  const [validated, setValidated] = useState(false);
  const [localExpensesData, setLocalExpensesData] = useState([]);
  const [transactionNumber, setTransactionNumber] = useState("");
  const [date, setDate] = useState("");
  // const [processDate, setProcessDate] = useState("");
  const [payExpensesDate, setPayExpensesDate] = useState("");
  const [currentDate, setCurrentDate] = useState("");
  const [currencyName, setCurrencyName] = useState("");
  const [totalAmountSum, setTotalAmountSum] = useState(0);
  const [items, setItems] = useState([
    // {
    //   transactionId: "",
    //   expensesType: "",
    //   expensesDate: "",
    //   totalAmount: "",
    //   description: "",
    // },
  ]);
  // const [editIndex, setEditIndex] = useState(null);
  const foreignExpenses = foreign_url === "local" ? "LOCAL" : "OVERSEAS";
  const [selectedRowTransactions, setSelectedRowTransactions] = useState([]);

  //useState sa payment method
  const [subject1, setSubject1] = useState("");
  const [subject2, setSubject2] = useState("");
  const [subject3, setSubject3] = useState("");
  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);
  const [selectedPayment, setSelectedPayment] = useState("Bank");
  const [onlinePaymentCheckbox, setOnlinePaymentCheckbox] = useState(false);
  const [bankAmount, setBankAmount] = useState(0);
  const [checkNumber, setCheckNumber] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [accountName, setAccountName] = useState("");
  const [amountInputted, setAmountInputted] = useState(""); //amount 'to sa payment method
  const [onlineWalletRemarks, setOnlineWalletRemarks] = useState("");
  const [totalPayment, setTotalPayment] = useState(0);
  const [isAmountDisabled, setIsAmountDisabled] = useState(true);
  const [currency_db, setCurrency_db] = useState([]);
  const [selected_currency_id, setSelected_currency_id] = useState("");
  const [floatPayment, setFloatPayment] = useState([]);
  const [currencyRate, setCurrencyRate] = useState(1);
  const [overallDiscount, setOverallDiscount] = useState(0);

  //useState sa additional expenses
  const [activeTab, setActiveTab] = useState("paymentList");
  const [expenses, setExpenses] = useState({
    additional: {
      0: {
        subject1: "",
        subject2: "",
        subject3: "",
        payment_method: "",
        remarks: "",
        check: "",
        amount: "",
        subject2Options: [],
        subject3Options: [],
        type: "additional",
        disabledSubject2: true,
        disabledSubject3: true,
        disabledAmount: true,
        LoanORAccount: "",
        rate: "",
        currentAmount: "",
      },
    },
    deduction: {
      0: {
        subject1: "",
        subject2: "",
        subject3: "",
        payment_method: "",
        remarks: "",
        check: "",
        amount: "",
        subject2Options: [],
        subject3Options: [],
        type: "deduction",
        disabledSubject2: true,
        disabledSubject3: true,
        disabledAmount: true,
        rate: "",
        currentAmount: "",
      },
    },
  });
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [selectedRow, setSelectedRow] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterColumn, setFilterColumn] = useState("all");
  const currencyRef = useRef(null);
  const paymentCounterRef = useRef(0);

  const [accessType, setAccessType] = useState("");
  // Access type (Management/Employee) of the logged in user, used to decide
  // whether the account balance is shown or hidden on this screen.
  const fetchAccessType = () => {
    axios
      .get(`${BASE_URL}/userRole/getUserAccessType/${userLoggedID}`)
      .then((res) => {
        setAccessType(res.data.accessType);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (userLoggedID) {
      fetchAccessType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedID]);

  // Subject 2 Payment Method Options for dropdown select
  const subject2Options = subject2DataList?.map((item) => {
    return {
      value: item.id,
      label: item.subject_name,
      subject_type: item.subject_type,
    };
  });

  // Subject 3 Payment Method Options for dropdown select
  const subject3Options = subject3DataList.map((item) => {
    return {
      value: item.id,
      label: item.account_name,
    };
  });

  const deletePayment = (item, index) => {
    setFloatPayment((prev) => {
      return prev.filter((_, i) => {
        return index !== i;
      });
    });
    // setTotalAmountSum((prev) => {
    //   return prev + item.amountInputted;
    // });
    setTotalPayment((prev) => prev - item.amountInputted);
  };

  const submitModal = () => {
    // const filteredExpensesData = localExpensesData
    //   .filter((item) => item.checkbox == true)
    //   .map((item) => {
    //     return {
    //       transactionId: item.transaction_id,
    //       expensesType: `${item.expenses2.expenses_one.expenses_type_one} (${item.expenses2.sub_type})`,
    //       expensesDate: item.expenses_date
    //         ? new Date(item.expenses_date).toISOString().split("T")[0]
    //         : "",
    //       totalAmount: item.totalAmount,
    //       description: item.desc,
    //     };
    //   });

    // setLocalExpensesData((prev) => {
    //   return prev.filter((item) => !selectedRow.includes(item.transaction_id));
    // });
    const mergedData = [
      ...new Set([...selectedRow, ...selectedRowTransactions]),
    ];

    fetchExpensesList(foreign_url, selected_currency_id, mergedData);
    setSelectedRowTransactions(mergedData);
    setFilterColumn("all");
    setSearchTerm("");
    // setSelectedRow([]);
    setShow(false);
  };

  const handleIndividualCheckBoxChange = (transaction_id) => {
    if (selectedRow.includes(transaction_id)) {
      setSelectedRow((prev) => {
        return prev.filter((item) => transaction_id !== item);
      });
    } else {
      setSelectedRow((prev) => {
        return [...prev, transaction_id];
      });
    }
  };

  const handleAllCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked === true) {
      setSelectedRow(localExpensesData.map((item) => item.transaction_id));
    } else {
      setSelectedRow([]);
    }
  };

  const columns = [
    {
      name: (
        <input type="checkbox" onChange={(e) => handleAllCheckboxChange(e)} />
      ),
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRow.includes(row.transaction_id)}
          onChange={() => handleIndividualCheckBoxChange(row.transaction_id)}
        />
      ),
    },
    {
      name: "Transaction ID",
      selector: (row) => (
        <>
          <div className="d-none">{row.transaction_id}</div>
          <div>{row.client_transaction_id}</div>
        </>
      ),
    },
    {
      name: "Cheque Number",
      selector: (row) => (row.expensesCheque ? row.expensesCheque : "---"),
    },
    {
      name: "Remarks",
      selector: (row) => (row.desc ? row.desc : "---"),
    },
    {
      name: "Expenses Type",
      selector: (row) =>
        `${row.expenses2.expenses_one.expenses_type_one} (${row.expenses2.sub_type})`,
    },
    {
      name: "Expenses Date",
      selector: (row) => format(row.expenses_date, "MMM/dd/yyyy"),
      // row.expenses_date
      //   ? new Date(row.expenses_date).toISOString().split("T")[0]
      //   : "",
    },
    {
      name: "Amount",
      selector: (row) => formatToTwoDecimal(row.totalAmount),
    },
  ];

  // Function to add a new expenses row
  const addNewItem = () => {
    if (!selected_currency_id) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("center-swal-text");
      wrapper.innerHTML =
        "Please select currency first to proceed to the Expenses List";

      swal({
        icon: "warning",
        title: "Currency Selection Required",
        content: wrapper,
        button: "OK",
      }).then(() => {
        if (currency_db.length > 0) {
          currencyRef.current.focus();
          currencyRef.current.showPicker();
        }
      });

      return;
    }
    handleShow();
  };

  // Function to delete a row
  const deleteItem = (item, index) => {
    // if (items.length === "11111111-1111-1111-1111-111111111111") {
    //   // Prevent deleting the last row if there's only one row
    //   return;
    // }

    setLocalExpensesData((prev) => {
      return [...prev, item];
    });

    setItems((prev) => {
      return prev.filter((_, i) => index !== i);
    });

    setSelectedRow((prev) => {
      return prev.filter((itemRow) => itemRow !== item.transaction_id);
    });

    setSelectedRowTransactions((prev) => {
      return prev.filter((itemRow) => itemRow !== item.transaction_id);
    });

    // const updatedItems = [...items];
    // updatedItems.splice(index, 1);
    // setItems(updatedItems);

    // const deletedItem = items.find((_, i) => {
    //   return index == i;
    // });

    // console.log(deletedItem, "deleted Item");
    // const splittedExpensesType = deletedItem.expensesType.split("(");
    // setLocalExpensesData((prev) => [

    //   ...prev,
    //   {
    //     transaction_id: deletedItem.transactionId,
    //     desc: deletedItem.description,
    //     expenses2: {
    //       expenses_one: {
    //         expenses_type_one: splittedExpensesType[0].trim(),
    //       },
    //       sub_type: splittedExpensesType[1].trim().replace(/\)/g, ""),
    //     },
    //     expenses_date: deletedItem.expensesDate,
    //     totalAmount: deletedItem.totalAmount,
    //     checkbox: false,
    //   },
    // ]);
  };

  // Function to toggle edit mode
  // const toggleEdit = (index) => {
  //   setEditIndex(editIndex === index ? null : index);
  // };

  const fetchTransactionCode = () => {
    axios
      .get(BASE_URL + "/paylocalexpenses/payLocalExpensesTransactionCode")
      .then((res) => {
        setTransactionNumber(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCurrency = async () => {
    const foreign =
      foreign_url.charAt(0).toUpperCase() +
      foreign_url.substring(1, foreign_url.length);
    await axios
      .get(BASE_URL + "/currency/expense-currency", {
        params: {
          foreign,
        },
      })
      .then((response) => {
        setCurrency_db(response.data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  };

  const handleCurrencyChange = (value) => {
    const hasItems = items.length > 0;
    const hasPayments = floatPayment.length > 0;

    const proceedWithCurrencyChange = () => {
      setSelected_currency_id(value);

      const currency_symbol = currency_db.find(
        (currency) => String(currency.id) === String(value),
      );

      if (currency_symbol) {
        setCurrencyName(currency_symbol.currency_name);
        setCurrencyRate(currency_symbol.currency_rate);
        //   {
        //     transactionId: "",
        //     expensesType: "",
        //     expensesDate: "",
        //     totalAmount: "",
        //     description: "",
        //   },
        // ]);
      }

      setItems([]); // clear expense rows
      setFloatPayment([]); // clear payment list
      setTotalPayment(0); // reset payment total
      paymentCounterRef.current = 0; // reset payment sequence counter
      setSelectedRowTransactions([]); // clear checked transaction IDs
      setSelectedRow([]); // clear modal checkbox selections
      setOverallDiscount(0);

      fetchExpensesList(foreign_url, value, []); // pass empty array instead of stale selectedRowTransactions
    };

    if (hasItems || hasPayments) {
      swal({
        title: "Change Currency?",
        text: "Changing the currency will clear all added expense rows and payment entries. Do you want to continue?",
        icon: "warning",
        buttons: ["Cancel", "Continue"],
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          proceedWithCurrencyChange();
        }
      });
    } else {
      proceedWithCurrencyChange();
    }
  };

  const pagination = useServerPagination(
    BASE_URL + "/paylocalexpenses/getLocalExpensesData",
    10,
  );

  const fetchExpensesList = (
    foreign_url,
    currency_id,
    selectedTransactions = [],
  ) => {
    pagination.updateParams({
      foreign: foreign_url,
      currency_id: currency_id,
      searchText: searchTerm,
      filterColumn,
      selectedTransactions,
    });
    // axios
    //   .get(BASE_URL + "/paylocalexpenses/getLocalExpensesData", {
    //     params: {
    //       foreign: foreign_url,
    //       currency_id: currency_id,
    //       searchText: searchTerm,
    //       filterColumn,
    //     },
    //   })
    //   .then((res) => {
    //     setLocalExpensesData(
    //       res.data.filter(
    //         (data) =>
    //           !items
    //             .map((item) => item.transaction_id)
    //             .includes(data.transaction_id)
    //       )
    //     );
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  //section para sa payment method to
  const handleSubject1Change = (event) => {
    const selectedSubject1 = event.target.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      account_selected = "Owner's Equity Account";
    }

    // Reset downstream selections and the account balance immediately,
    // so they clear the moment Subject 1 changes instead of depending on
    // the Subject 2 fetch below.
    setSubject2("");
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);

    try {
      axios
        .get(`${BASE_URL}/paylocalexpenses/getSubject1LocalExpenses`, {
          params: {
            account_selected: account_selected,
            selectedPayment,
          },
        })
        .then((res) => {
          setSubject1(selectedSubject1);
          setIsSubject2Disabled(false); // Enable Subject 2 after Subject 1 selection
          setSubject2DataList(res.data); //retrieve subject 2 data
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleSubject2Change = (selectedOption) => {
    const selectedSubject2 = selectedOption;

    // Reset the account selection and balance immediately when Subject 2
    // changes.
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
    setIsSubject3Disabled(true);

    try {
      axios
        .get(`${BASE_URL}/paylocalexpenses/getSubject3LocalExpenses`, {
          params: {
            subjectId: selectedSubject2?.value,
            totalAmountSum,
            selected_currency_id,
          },
        })
        .then((res) => {
          // Backend already filters accounts to selected_currency_id (the
          // currency currently being processed in expenses).
          setSubject3DataList(res.data);
          setSubject2(selectedSubject2);
          setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
        });
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  const handleTransactionChange = (index, transactionId) => {
    const transaction = localExpensesData.find(
      (t) => t.id.toString() === transactionId,
    );
    if (transaction) {
      const updatedItems = [...items];
      updatedItems[index] = {
        ...updatedItems[index],
        transactionId: transactionId,
        id: transaction.transaction_id,
        expensesType: `${transaction.expenses2.expenses_one.expenses_type_one} (${transaction.expenses2.sub_type})`, // or another suitable field for 'expensesType'
        expensesDate: transaction.expenses_date
          ? new Date(transaction.expenses_date).toISOString().split("T")[0]
          : "",
        totalAmount: transaction.totalAmount || 0,
        description: transaction.description || "n/a",
        remarks: transaction.desc,
      };
      setItems(updatedItems);
      console.log("Selected transaction ID:", transactionId);
      console.log("Updated items:", updatedItems);
    }
  };

  const getAvailableTransactionIds = (index) => {
    const selectedTransactionIds = items
      .map((item) => item.transactionId)
      .filter((id) => id);
    return localExpensesData.filter(
      (transaction) =>
        !selectedTransactionIds.includes(transaction.id.toString()) ||
        items[index].transactionId === transaction.id.toString(),
    );
  };

  useEffect(() => {
    const sum = items.reduce(
      (acc, item) => acc + parseFloat(item.totalAmount || 0),
      0,
    );

    console.log(items);
    setTotalAmountSum(sum);
  }, [items]);

  const handlePaymentMethod = (e) => {
    const paymentMethod = e.target.value;
    setSelectedPayment(paymentMethod);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setBankAmount(0);
    setAccountName("");
  };

  const handleOnlineCheck = (e) => {
    setOnlinePaymentCheckbox(e.target.checked);
  };

  const handleAccountChange = (selectedOption) => {
    const selectedAccountId = selectedOption?.value;
    setSubject3(selectedOption);

    // Reset first so the balance clears immediately if the selection is
    // cleared or doesn't match a known account.
    setBankAmount(0);
    setAccountName("");

    const selectedAccount = subject3DataList.find(
      (account) => String(account.id) === String(selectedAccountId),
    );

    if (selectedAccount) {
      setBankAmount(selectedAccount.amount);
      setAccountName(selectedAccount.account_name);
      setAmountInputted(payableExpenses.toFixed(2).toString());
    }
  };

  const totalCashPaid = floatPayment.reduce(
    (acc, data) =>
      data.paymentMethod === "Cash"
        ? acc + parseFloat(data.amountInputted || 0)
        : acc,
    0,
  );

  const totalBankPaid = floatPayment.reduce(
    (acc, data) =>
      data.checkNumber === "" &&
      data.refNumber === "" &&
      data.paymentMethod === "Bank"
        ? acc + parseFloat(data.amountInputted || 0)
        : acc,
    0,
  );

  const totalCheckPaid = floatPayment.reduce(
    (acc, data) =>
      data.checkNumber !== ""
        ? acc + parseFloat(data.amountInputted || 0)
        : acc,
    0,
  );

  const totalOnlinePaid = floatPayment.reduce(
    (acc, data) =>
      data.refNumber !== "" && data.paymentMethod === "Bank"
        ? acc + parseFloat(data.amountInputted || 0)
        : acc,
    0,
  );

  const totalPaymentMethodAmount =
    totalCashPaid + totalBankPaid + totalCheckPaid + totalOnlinePaid;

  // const onInputFloat = (e) => {
  //   e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  // };

  // const handleAmountValue = (value) => {
  //   if (value == ".") {
  //     setAmountInputted((prev) => prev + ".");
  //   }
  //   let inputValue = value.replace(/[^0-9.]/g, "");

  //   let [integerPart, decimalPart] = inputValue.split(".");
  //   if (integerPart) {
  //     integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }

  //   let formattedValue =
  //     decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
  //   const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

  //   let formatAmount = inputValue.replace(/,/g, "");
  //   // Convert to number and format with commas
  //   let numericValue = parseFloat(formatAmount);

  //   // prettier-ignore
  //   // Check if the input value is greater than the totalAmountSum
  //   if (numericValue > payableExpenses && new Date(date) <= new Date(currentDate)) {
  //     swal({
  //       title: "Oppss!",
  //       text: "Please input not greater than the balance",
  //       icon: "error",
  //       buttons: false,
  //       timer: 2000,
  //       dangerMode: true,
  //     }).then(() => {
  //       setAmountInputted("");
  //     });
  //   } else {
  //     setAmountInputted(cleanedValue);
  //   }
  // };

  const handleAmountValue = (val) => {
    if (val === "" || val === ".") {
      setAmountInputted(val);
      return;
    }

    const numericValue = parseFloat(val);
    const formatBankAmount = parseNumber(bankAmount);
    const isLiability = subject1 === "Liabilities Account";

    const balance_now = payableExpenses;
    let maxAllowedAmount = balance_now;
    let triggeredBy = "expense_balance";

    if (!isLiability && formatBankAmount < balance_now) {
      maxAllowedAmount = formatBankAmount;
      triggeredBy = "account_balance";
    }

    if (numericValue > maxAllowedAmount) {
      if (triggeredBy === "account_balance") {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text: `Please input not greater than the account balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`,
          buttons: false,
          timer: 2000,
        });
      } else {
        swal({
          icon: "warning",
          title: "Amount Adjusted",
          text: `Please input not greater than the balance. The amount adjusted to match your remaining balance (${truncateToTwoDecimals(maxAllowedAmount)}).`,
          buttons: false,
          timer: 2000,
        });
      }
      setAmountInputted(maxAllowedAmount.toFixed(2).toString());
      return;
    }

    setAmountInputted(val);
  };

  //section para sa payment method to end

  //section para sa mga add and deduction expenses

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleSubject1AddDeductExpensesChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject1: value,
          subject2: "",
          subject3: "",
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    }));

    axios
      .get(BASE_URL + "/paylocalexpenses/getSubjectAddDeductExpenses", {
        params: { account_selected: value },
      })
      .then((res) => {
        setExpenses((prev) => ({
          ...prev,
          [expenseType]: {
            ...prev[expenseType],
            [rowId]: {
              ...prev[expenseType][rowId],
              subject2Options: res.data,
              disabledSubject2: false,
            },
          },
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubject2AddDeductExpensesChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject2: value,
          subject3: "",
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    }));

    if (value === "Loan_Unique") {
      axios
        .get(
          BASE_URL + "/paylocalexpenses/getSubject3AddDeductExpensesFORLOAN",
          {
            params: {
              selected_currency_id,
            },
          },
        )
        .then((res) => {
          console.log("Subject 2 Change", res.data);
          setExpenses((prev) => ({
            ...prev,
            [expenseType]: {
              ...prev[expenseType],
              [rowId]: {
                ...prev[expenseType][rowId],
                subject3Options: res.data,
                disabledSubject3: false,
              },
            },
          }));
        });
    } else {
      axios
        .get(BASE_URL + "/paylocalexpenses/getSubject3AddDeductExpenses", {
          params: {
            subjectId: value,
            totalAmountSum,
            selected_currency_id,
          },
        })
        .then((res) => {
          setExpenses((prev) => ({
            ...prev,
            [expenseType]: {
              ...prev[expenseType],
              [rowId]: {
                ...prev[expenseType][rowId],
                subject3Options: res.data,
                disabledSubject3: false,
              },
            },
          }));
        });
    }
  };

  const handleSubject3AddExpensesChange = (
    rowId,
    value,
    expenseType,
    loanORAccount,
    currAmount,
  ) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: {
          ...prev[expenseType][rowId],
          subject3: value,
          LoanORAccount: loanORAccount,
          disabledAmount: false,
          currentAmount: currAmount,
        },
      },
    }));
  };

  const handleRemarksChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: { ...prev[expenseType][rowId], remarks: value },
      },
    }));
  };

  // function to handle currency rate formatting
  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleAmountChange = (rowId, value, expenseType) => {
    setExpenses((prev) => {
      const currentRow = prev[expenseType][rowId];

      if (value === ".") {
        value = "0.";
      }

      let inputValue = value.replace(/[^0-9.]/g, "");
      let [integerPart, decimalPart] = inputValue.split(".");

      if (integerPart) {
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      let formattedValue =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
      let formatAmount = inputValue.replace(/,/g, "");
      let numericValue = parseFloat(formatAmount) || 0;

      if (numericValue > currentRow.currentAmount) {
        swal({
          icon: "error",
          title: "Enter another amount",
          text: `Amount cannot exceed ${formatToTwoDecimal(currentRow.currentAmount)}`,
          buttons: false,
          timer: 2000,
        });
        return prev;
      }

      return {
        ...prev,
        [expenseType]: {
          ...prev[expenseType],
          [rowId]: { ...currentRow, amount: formattedValue },
        },
      };
    });
  };

  const handleRateChange = (rowId, value, expenseType) => {
    setExpenses((prev) => ({
      ...prev,
      [expenseType]: {
        ...prev[expenseType],
        [rowId]: { ...prev[expenseType][rowId], rate: value },
      },
    }));
  };

  const handleAddRow = (type) => {
    const newRowId = Object.keys(expenses[type]).length;
    setExpenses((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [newRowId]: {
          subject1: "",
          subject2: "",
          subject3: "",
          payment_method: "",
          remarks: "",
          check: "",
          amount: "",
          subject2Options: [],
          subject3Options: [],
          type: type,
          disabledSubject2: true,
          disabledSubject3: true,
          disabledAmount: true,
        },
      },
    }));
  };

  const handleRemoveRow = (rowId, type) => {
    setExpenses((prev) => {
      const updated = { ...prev[type] };
      delete updated[rowId];
      return { ...prev, [type]: updated };
    });
  };

  const sumAmounts = (type) => {
    return Object.values(expenses[type]).reduce((acc, expense) => {
      const multiplyTo =
        selected_currency_id === "11111111-1111-1111-1111-111111111111"
          ? 1
          : expense.rate;
      return (
        acc +
        (parseFloat(String(expense.amount).replace(/,/g, "")) || 0) * multiplyTo
      );
    }, 0);
  };

  const toPayAmount =
    parseFloat(totalAmountSum) - parseFloat(overallDiscount || 0); // Expenses balance
  const totalPayAmount = parseFloat(totalPayment); // Total payment
  const additionalExpense = sumAmounts("additional"); // Total additional expenses
  const deductionExpense = sumAmounts("deduction"); // Total deduction expenses

  const balance = toPayAmount + additionalExpense - deductionExpense; // Balance
  const totalPayable = additionalExpense + toPayAmount; // Expenses + Additional Expenses
  const totalWithDeductions = deductionExpense + totalPayAmount; // Deduction Expenses + Payments
  const payableExpenses = totalPayable - totalWithDeductions; // Overall expense total // prettier-ignore

  const renderExpenseTable = (type) => {
    // Subject 1 Options for dropdown select
    const subject1AddDeductOptions = [
      "Account-List",
      "Liabilities Account",
      "Asset Account",
      "Owner's Equity Account",
    ].map((item) => ({
      value: item,
      label: item,
    }));

    // Subject 2 Options for dropdown select
    const subject2AddDeductOptions = (row) =>
      row.subject2Options.map((data) => ({
        value: data.id,
        label: data.subject_name,
      }));

    // Subject 3 Options for dropdown select
    const subject3AddDeductOptions = (row) =>
      row.subject3Options.map((data) =>
        row.subject1 === "Loan_Unique"
          ? {
              value: data.id,
              label: data.loan_name,
            }
          : { value: data.id, label: data.account_name },
      );

    return (
      <Table bordered hover>
        <thead>
          <tr>
            <th>Subject1</th>
            <th>Subject2</th>
            <th>Subject3</th>
            <th>Remarks</th>
            <th>Amount</th>
            {selected_currency_id ===
            "11111111-1111-1111-1111-111111111111" ? null : (
              <>
                <th>Rate</th>
              </>
            )}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(expenses[type]).map(([rowId, row]) => (
            <tr key={rowId}>
              <td>
                {/* <Form.Control
                  as="select"
                  value={row.subject1}
                  onChange={(e) =>
                    handleSubject1AddDeductExpensesChange(
                      rowId,
                      e.target.value,
                      type
                    )
                  }
                  required
                >
                  <option disabled value="" selected>
                    Select Subject 1
                  </option>
                  <option value="Account-List">Account-List</option>
                  <option value="Liabilities Account">
                    Liabilities Account
                  </option>
                  <option value="Asset Account">Asset Account</option>
                  <option value="Owner's Equity Account">
                    Owner's Equity Account
                  </option>
                  {type === "additional" && (
                  <option value="Loan_Unique">Loan</option>
                )}
                </Form.Control> */}
                <Select
                  options={subject1AddDeductOptions}
                  value={subject1AddDeductOptions.find(
                    (item) => item?.value === row.subject1,
                  )}
                  onChange={(selectedOption) =>
                    handleSubject1AddDeductExpensesChange(
                      rowId,
                      selectedOption?.value,
                      type,
                    )
                  }
                  menuPortalTarget={document.body}
                  placeholder={`Select Subject 1`}
                  styles={selectCustomStyles(row.subject1)}
                  required
                />
              </td>
              <td>
                {/* <Form.Control
                as="select"
                value={row.subject2}
                onChange={(e) =>
                  handleSubject2AddDeductExpensesChange(
                    rowId,
                    e.target.value,
                    type
                  )
                }
                required
                disabled={row.disabledSubject2}
              >
                <option disabled value="">
                  Select Subject 2
                </option>
                {row.subject1 === "Loan_Unique" ? (
                  <option value="Loan_Unique">Loan</option>
                ) : (
                  row.subject2Options.map((data) => (
                    <option key={data.id} value={data.id}>
                      {`${data.subject_name}`}
                    </option>
                  ))
                )}
              </Form.Control> */}
                <Select
                  options={subject2AddDeductOptions(row)}
                  value={subject2AddDeductOptions(row).find(
                    (item) => item?.value === row.subject2,
                  )}
                  onChange={(selectedOption) =>
                    handleSubject2AddDeductExpensesChange(
                      rowId,
                      selectedOption?.value,
                      type,
                    )
                  }
                  menuPortalTarget={document.body}
                  placeholder={`Select Subject 2`}
                  styles={selectCustomStyles(row.subject2)}
                  isDisabled={row.disabledSubject2}
                  required
                />
              </td>
              <td>
                {/* <Form.Control
                  as="select"
                  value={row.subject3}
                  onChange={(e) => {
                    const selectedValue = e.target.value;

                    const selectedOption = row.subject3Options.find(
                      (option) => option.id == parseFloat(selectedValue)
                    );

                    const currAmount = selectedOption?.amount || 0;

                    handleSubject3AddExpensesChange(
                      rowId,
                      selectedValue,
                      type,
                      row.subject1 === "Loan_Unique" ? "loan" : "account",
                      currAmount
                    );
                  }}
                  required
                  disabled={row.disabledSubject3}
                >
                  <option disabled value="">
                    Select Subject 3
                  </option>
                  {row.subject3Options.map((data) =>
                    row.subject1 === "Loan_Unique" ? (
                      <option key={data.id} value={data.id}>
                        {`${data.loan_name}`}
                      </option>
                    ) : (
                      <option key={data.id} value={data.id}>
                        {`${data.account_name}`}
                      </option>
                    )
                  )}
                </Form.Control> */}
                <Select
                  options={subject3AddDeductOptions(row)}
                  value={subject3AddDeductOptions(row).find(
                    (item) => item?.value === row.subject3,
                  )}
                  onChange={(selectedOption) => {
                    const selectedValue = selectedOption?.value;

                    const selectedOptions = row.subject3Options.find(
                      (option) => option.id === selectedValue,
                    );

                    const currAmount = selectedOptions?.amount || 0;

                    handleSubject3AddExpensesChange(
                      rowId,
                      selectedValue,
                      type,
                      row.subject1 === "Loan_Unique" ? "loan" : "account",
                      currAmount,
                    );
                  }}
                  menuPortalTarget={document.body}
                  isDisabled={row.disabledSubject3}
                  placeholder={`Select Subject 3`}
                  styles={selectCustomStyles(row.subject3)}
                  required
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.remarks}
                  onChange={(e) =>
                    handleRemarksChange(rowId, e.target.value, type)
                  }
                  placeholder="Description ..."
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={row.amount}
                  onChange={(e) =>
                    handleAmountChange(rowId, e.target.value, type)
                  }
                  placeholder="0.00"
                  required
                  disabled={row.disabledAmount}
                />
              </td>
              {selected_currency_id ===
              "11111111-1111-1111-1111-111111111111" ? null : (
                <>
                  <td>
                    <Form.Control
                      type="text"
                      value={row.rate}
                      onChange={(e) =>
                        handleRateChange(rowId, e.target.value, type)
                      }
                      placeholder="0.00"
                      required
                      disabled={row.disabledAmount}
                    />
                  </td>
                </>
              )}
              <td>
                <Button
                  variant="danger"
                  onClick={() => handleRemoveRow(rowId, type)}
                  disabled={rowId === "0"}
                >
                  Remove
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };
  //section para sa mga add and deduction expenses

  const handleAddPayment = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    // let formatAmountInputted = String(amountInputted).replace(/,/g, "");
    const formatAmount = parseFloat(amountInputted);

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill the red text fields",
        buttons: false,
        timer: 2000,
      });
    } else {
      if (formatAmount <= 0) {
        swal({
          icon: "error",
          title: "Amount Required",
          text: "The amount cannot be zero. Please enter a valid value.",
          buttons: "OK",
        });
        return;
      }

      if (
        selectedPayment === "Bank" &&
        checkNumber &&
        !(await validateCheckNumbers(checkNumber, {
          pending: floatPayment
            .filter((payment) => !payment.isDeleted)
            .map((payment) => payment.checkNumber),
        }))
      )
        return;

      swal({
        title: "Create this new expenses?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          // const newPayment = {
          //   paymentMethod: selectedPayment,
          //   subject1: subject1,
          //   subject2: subject2?.value,
          //   subject3: subject3?.value,
          //   accountName: accountName,
          //   amountInputted: parseFloat(formatAmountInputted),
          //   issuedDate: date,
          //   // processDate: processDate,
          //   checkNumber: checkNumber,
          //   refNumber: refNumber,
          //   remarks: onlineWalletRemarks,
          // };
          // setFloatPayment((prevPayments) => [...prevPayments, newPayment]);

          // Increment BEFORE the updater — state updaters must be pure and
          // React (StrictMode) may call them more than once. Doing the
          // increment here guarantees it runs exactly once per user action.
          paymentCounterRef.current += 1;
          const newIndex = paymentCounterRef.current;

          setFloatPayment((prevPayments) => {
            const newPayment = {
              paymentMethod: selectedPayment,
              subject1: subject1,
              subject2: subject2?.value,
              subject3: subject3?.value,
              accountName: accountName,
              amountInputted: formatAmount,
              issuedDate: date,
              checkNumber: checkNumber,
              refNumber: refNumber,
              remarks: onlineWalletRemarks,
              // processDate: payExpensesDate,
              transactionNumber: `${transactionNumber}_p${newIndex}`,
            };

            return [...prevPayments, newPayment];
          });
          setTotalPayment((prevTotal) => prevTotal + formatAmount);
          swal({
            icon: "success",
            title: "Payment Added",
            text: "The new payment has been added successfully",
            buttons: false,
            timer: 2000,
          }).then(() => {
            clearPaymentFields();
          });
        }
      });
    }
    setValidated(true);
  };

  const clearPaymentFields = () => {
    setValidated(false);
    setOnlinePaymentCheckbox(false);

    setRefNumber("");
    setOnlineWalletRemarks("");
    // setSelectedPayment("Bank");
    setAccountName("");
    setAmountInputted("");
    setCheckNumber("");
    setRefNumber("");
    setDate("");
    // setProcessDate("");
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
  };

  const dateValidation = async (selectedDate) => {
    try {
      const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
        params: {
          date: selectedDate,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleSavePayment = async () => {
    if (!items || items.length === 0) {
      swal({
        icon: "warning",
        title: "No Expenses Added",
        text: "Please add at least one expense before saving.",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    if (payExpensesDate === "") {
      swal({
        icon: "warning",
        title: "Process Date is required",
        text: "Please select the process date",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    dateValidation(payExpensesDate);

    if (!payExpensesDate) {
      swal({
        title: "Required Field Missing",
        text: "Please ensure Process Date is filled out.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
      return;
    }

    const confirmed = await swal({
      title: "Create this new expenses?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirmed) {
      try {
        const expensesToSubmit = [];

        // additional expenses
        for (const expense of Object.values(expenses.additional)) {
          expensesToSubmit.push({
            subject1: expense.subject1,
            subject2: expense.subject2,
            subject3: expense.subject3,
            remarks: expense.remarks,
            amount: parseFloat(String(expense.amount).replace(/,/g, "")),
            payment_method: expense.payment_method,
            type: "additional",
            LoanORAccount: expense.LoanORAccount,
            rate: expense.rate || 1,
          });
        }

        // deduction expenses
        for (const expense of Object.values(expenses.deduction)) {
          expensesToSubmit.push({
            subject1: expense.subject1,
            subject2: expense.subject2,
            subject3: expense.subject3,
            remarks: expense.remarks,
            amount: parseFloat(String(expense.amount).replace(/,/g, "")),
            payment_method: expense.payment_method,
            type: "deduction",
            LoanORAccount: "account",
            rate: expense.rate || 1,
          });
        }

        const res = await axios.post(
          `${BASE_URL}/paylocalExpenses/addPayment`,
          {
            items,
            payExpensesDate,
            transactionNumber,
            floatPayment,
            expenses: expensesToSubmit,
            foreign_url: foreign_url,
            userLoggedID,
            totalAmountSum: balance,
            currencyId: selected_currency_id,
            currencyRate,
            overallDiscount: overallDiscount,
          },
        );

        if (res.status === 200) {
          swal({
            title: "Success",
            text: "Payment Expenses has been added successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
            dangerMode: true,
          }).then(() => {
            // if (foreign_url === "local") {
            //   navigate("/accounting/local-expenses");
            // } else {
            //   navigate("/accounting/overseas-expenses");
            // }
            navigate("/accounting/local-expenses");
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 409) {
          swal({
            title: "Oopps!",
            text: "Action is prohibited because the date provided for the Process Date has already passed the posted cutoff.",
            icon: "error",
            button: true,
          });
          return;
        }

        console.error("Error saving payment:", error);
        swal({
          title: "Something went wrong",
          text: "Please contact your support immediately",
          icon: "error", // Changed to error for better clarity
          buttons: false,
          timer: 2000,
          dangerMode: true,
        });
      }
    } else {
      setValidated(false);
    }
    // setValidated(true);
  };

  const dateToday = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    // if (pagination.data.data) {
    //   setLocalExpensesData(
    //     pagination.data.data.filter(
    //       (data) =>
    //         !items
    //           .map((item) => item.transaction_id)
    //           .includes(data.transaction_id)
    //     )
    //   );
    // }

    setLocalExpensesData(pagination?.data?.data);

    if (pagination?.data?.items) {
      // Skip if all selectedRows already exist in items
      const existingIds = items.map((item) => item.transaction_id);
      const isFullySynced =
        selectedRow.every((id) => existingIds.includes(id)) &&
        items.length === selectedRow.length;

      if (isFullySynced) return;

      const newItems = pagination.data.items.filter(
        (item) =>
          selectedRow.includes(item.transaction_id) &&
          !existingIds.includes(item.transaction_id),
      );

      if (newItems.length > 0) {
        setItems((prev) => [
          ...prev,
          ...newItems.map((item) => ({
            ...item,
            expensesDiscountType: "percent",
            expensesDiscountValue: "",
            expensesDiscountOperator: "+",
            expensesDiscountConverted: 0,
          })),
        ]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.data.data]);

  console.log(selectedRow);

  useEffect(() => {
    // if (pagination.currentPage === 1 && localExpensesData?.length < 10) {
    //   pagination.setTotalPages(
    //     Math.ceil(localExpensesData?.length / pagination.itemsPerPage)
    //   );
    // }
  }, [localExpensesData]);

  useEffect(() => {
    fetchTransactionCode();
    fetchCurrency();
    setPayExpensesDate(dateToday());
    setCurrentDate(dateToday());
  }, []);

  useEffect(() => {
    if (amountInputted) {
      handleAmountValue(amountInputted);
    }
  }, [date]);

  useEffect(() => {
    fetchExpensesList(
      foreign_url,
      selected_currency_id,
      selectedRowTransactions,
    );
  }, [searchTerm]);

  useEffect(() => {
    setSearchTerm("");
  }, [filterColumn]);

  const handleItemDiscountChange = (index, key, value) => {
    setItems((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [key]: value,
      };
      return updated;
    });
  };

  useEffect(() => {
    let grossAmount = 0;
    let totalDiscount = 0;

    items.forEach((item) => {
      const amount = parseFloat(item.totalAmount) || 0;
      grossAmount += amount;

      let itemDiscount = 0;
      const discVal = parseFloat(item.expensesDiscountValue) || 0;

      if (item.expensesDiscountType === "amount") {
        itemDiscount = discVal;
      } else {
        itemDiscount = (discVal / 100) * amount;
      }

      if (item.expensesDiscountOperator === "-") {
        totalDiscount -= itemDiscount;
      } else {
        totalDiscount += itemDiscount;
      }
    });

    setTotalAmountSum(grossAmount);
    setOverallDiscount(totalDiscount);
  }, [items]);

  useEffect(() => {
    if (selectedPayment === "Cash") {
      if (payExpensesDate) {
        // Sync maturity date with the chosen process date
        setDate(payExpensesDate);
      } else {
        // Fallback to today if no date is picked
        const currentDate = dateToday();
        setPayExpensesDate(currentDate);
        setDate(currentDate);
      }
      setIsAmountDisabled(false);
    }
  }, [selectedPayment, payExpensesDate]);

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="w-100 p-2 d-flex flex-row justify-content-between">
        <div className="d-flex flex-column title-custom">
          <span className="fs-3">
            <Link to={"/accounting/local-expenses"} className="text-dark me-2">
              <i class="fa-solid fa-arrow-left"></i>
            </Link>
            {foreignExpenses} EXPENSES
          </span>
        </div>
      </div>

      <Container fluid className="mt-3">
        <Row className="p-2">
          <Col sm>
            <span>Transaction Number</span>
            <Form.Control
              type="text"
              className="p-2"
              value={transactionNumber}
              readOnly
            />
          </Col>
          <Col sm>
            <span>Process Date</span>
            <CustomDatePicker
              label={"Process Date"}
              selected={payExpensesDate ? new Date(payExpensesDate) : ""}
              handleDateChange={(selectedDate) => {
                if (!selectedDate) {
                  setPayExpensesDate("");
                  return;
                }
                const toDateOnly = (d) => {
                  const r = new Date(d);
                  r.setHours(0, 0, 0, 0);
                  return r;
                };
                if (date && toDateOnly(selectedDate) > toDateOnly(date)) {
                  swal({
                    icon: "warning",
                    title: "Invalid Process Date",
                    text: "Process Date cannot be greater than the Maturity Date.",
                    buttons: false,
                    timer: 2500,
                  });
                  return;
                }
                setPayExpensesDate(selectedDate);
                // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                // dateValidation(selectedDate);
                // postedCutoffValidation(selectedDate, setPayExpensesDate, "Process Date");
                warnCutoffDate(
                  selectedDate,
                  setPayExpensesDate,
                  "Process Date",
                );
              }}
              setter={setPayExpensesDate}
              CustomInput={CustomInput}
              isRequired={true}
              validated={validated}
              //disabled={selectedPayment === "Cash"}
              // "Today" button
              dateValidation={(today) =>
                warnCutoffDate(today, setPayExpensesDate, "Process Date")
              }
              maxDate={
                date
                  ? new Date(new Date(date).setHours(23, 59, 59, 999))
                  : undefined
              }
            />
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>
              Currency <span className="text-danger">*</span>
              {/* {selected_currency_id &&
              selected_currency_id !==
                "11111111-1111-1111-1111-111111111111" ? (
                <span className="text-muted mb-1">
                  {" "}
                  Current Rate: {currencyRate}
                </span>
              ) : null} */}
            </span>
            <Form.Select
              required
              onChange={(e) => {
                handleCurrencyChange(e.target.value);
                setSubject1("");
                setSubject2("");
                setSubject3("");
                setIsSubject2Disabled(true);
                setIsSubject3Disabled(true);
              }}
              onMouseDown={(e) => {
                if (currency_db.length === 0) {
                  e.preventDefault();
                  const foreign =
                    foreign_url.charAt(0).toUpperCase() + foreign_url.slice(1);
                  const wrapper = document.createElement("div");
                  wrapper.classList.add("center-swal-text");
                  wrapper.innerHTML = `There are no approved transactions in the <strong>Create Expenses</strong> module that haven't already been added to <strong>${foreign} Expense</strong>.`;

                  swal({
                    icon: "warning",
                    title: "Warning",
                    content: wrapper,
                  });
                }
              }}
              className="p-2"
              value={selected_currency_id}
              ref={currencyRef}
            >
              <option value="" selected disabled>
                Select Currency
              </option>
              {currency_db.map((data) => (
                <option key={data.id} value={data.id}>
                  {`${data.currency_name}`}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col sm>
            <span>Balance</span>
            <InputGroup className="mb-2">
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2"
                placeholder="0.00"
                value={formatToTwoDecimal(balance)}
                readOnly
              />
            </InputGroup>
          </Col>
        </Row>
        <Row className="p-2">
          <Col sm>
            <span>Overall Expenses Discount</span>
            <InputGroup>
              <InputGroup.Text>
                {currencySymbol[currencyName] || ""}
              </InputGroup.Text>
              <Form.Control
                type="text"
                className="p-2 pointer-events-none"
                id="overallDiscountAmount"
                value={formatToTwoDecimal(overallDiscount)}
                readOnly
              />
            </InputGroup>
          </Col>
          <Col sm>
            {selected_currency_id &&
            selected_currency_id !== "11111111-1111-1111-1111-111111111111" ? (
              <div className="d-none">
                <span>
                  Currency Rate<span className="text-danger">*</span>
                </span>
                <Form.Control
                  type="text"
                  className="p-2"
                  required
                  onChange={handleCurrencyRateChange}
                  value={currencyRate}
                  readOnly
                />
              </div>
            ) : null}
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Expenses List</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-2 p-2 new-item-custom scrollable-contents">
          <Table bordered hover responsive className="fixed-inputs-table">
            <thead className="table-light">
              <tr>
                <th className="p-2">Transaction ID</th>
                <th className="p-2">Remarks</th>
                <th className="p-2">Expenses Type</th>
                <th className="p-2">Expenses Date</th>
                <th className="p-2">Amount</th>
                <th className="p-2">Expenses Discount</th>
                {/* <th className="p-2">Description</th> */}
                <th className="p-2">Action</th>
              </tr>
            </thead>
            {items?.length > 0 ? (
              <tbody>
                {items?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Control
                        className="d-none"
                        value={item.transaction_id || "---"}
                        type="text"
                        readOnly
                      />
                      <Form.Control
                        value={item.client_transaction_id || "---"}
                        type="text"
                        readOnly
                      />
                    </td>
                    <td>
                      {/* <select
                        disabled={selected_currency_id === ""}
                        className="form-select form-select-sm p-2"
                        onChange={(e) =>
                          handleTransactionChange(index, e.target.value)
                        }
                        value={item.transactionId}
                      >
                        <option value="" disabled>
                          Select Remarks
                        </option>
                        {getAvailableTransactionIds(index).map(
                          (transaction) => (
                            <option key={transaction.id} value={transaction.id}>
                              {transaction.desc}
                            </option>
                          )
                        )}
                      </select> */}
                      <Form.Control
                        value={item.desc || "---"}
                        type="text"
                        readOnly
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        size="sm"
                        className="p-2"
                        readOnly
                        value={
                          `${item.expenses2.expenses_one.expenses_type_one} (${item.expenses2.sub_type})` ||
                          ""
                        }
                      />
                    </td>
                    <td>
                      {/* <input
                          type="date"
                          className="form-control form-control-sm p-2"
                          readOnly
                          value={item.expenses_date || ""}
                        /> */}

                      <DatePicker
                        selected={item.expenses_date}
                        dateFormat="MMM/dd/yyyy"
                        className="form-control form-control-sm p-2"
                        readOnly
                      />
                    </td>
                    <td>
                      <InputGroup>
                        <InputGroup.Text>
                          {currencySymbol[currencyName] || ""}
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          size="sm"
                          className="p-2"
                          value={formatToTwoDecimal(item.totalAmount)}
                          readOnly
                        />
                      </InputGroup>
                    </td>
                    {/* <td className="text-center">
                      <div className="input-group mb-2">
                        <Form.Control
                          type="text"
                          className="form-control-sm p-2"
                          id="inlineFormInputGroup"
                          value={item.description}
                          readOnly
                        />
                      </div>
                    </td> */}
                    <td>
                      <InputGroup>
                        <Button
                          type="button"
                          variant="primary"
                          id={`discount-type-${index}`}
                          title={
                            item.expensesDiscountType === "percent"
                              ? "Discount type: Percentage (%). Click to switch to Fixed Amount"
                              : "Discount type: Fixed Amount. Click to switch to Percentage (%)"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          onClick={() => {
                            if (!selected_currency_id) return;
                            const newType =
                              item.expensesDiscountType === "percent"
                                ? "amount"
                                : "percent";
                            let newValue = item.expensesDiscountValue;

                            if (
                              newType === "percent" &&
                              parseFloat(newValue) >= 100
                            ) {
                              newValue = 100;
                            }

                            setItems((prev) => {
                              const updated = [...prev];
                              updated[index] = {
                                ...updated[index],
                                expensesDiscountType: newType,
                                expensesDiscountValue: newValue,
                              };
                              return updated;
                            });
                          }}
                        >
                          {item.expensesDiscountType === "percent"
                            ? "%"
                            : currencySymbol[currencyName] || ""}
                        </Button>
                        <NumberInDecimals
                          className="form-control p-2"
                          disabled={!selected_currency_id || !items.length}
                          value={item.expensesDiscountValue || ""}
                          placeholder="0.00"
                          decimals={2}
                          max={
                            item.expensesDiscountType === "percent"
                              ? 100
                              : parseFloat(item.totalAmount)
                          }
                          onChange={(val) => {
                            handleItemDiscountChange(
                              index,
                              "expensesDiscountValue",
                              val,
                            );
                          }}
                        />
                        <Button
                          type="button"
                          id={`discount-operator-${index}`}
                          variant="primary"
                          title={
                            item.expensesDiscountOperator === "+"
                              ? "Operator: Adding discount (+). Click to subtract instead"
                              : "Operator: Subtracting discount (−). Click to add instead"
                          }
                          style={{ userSelect: "none", minWidth: "2.5rem" }}
                          onClick={() => {
                            if (!selected_currency_id) return;
                            const newOp =
                              item.expensesDiscountOperator === "+" ? "-" : "+";
                            handleItemDiscountChange(
                              index,
                              "expensesDiscountOperator",
                              newOp,
                            );
                          }}
                        >
                          {item.expensesDiscountOperator || "+"}
                        </Button>
                      </InputGroup>
                    </td>
                    <td className="text-center">
                      {/* <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => toggleEdit(index)}
                      >
                        <i
                          className={`fa-solid ${
                            editIndex === index ? "fa-save" : "fa-edit"
                          }`}
                        ></i>
                      </button> */}
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => deleteItem(item, index)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <caption className="text-center mt-3">
                There are no records to display
              </caption>
            )}
          </Table>
        </div>
        <div className="w-100 d-flex justify-content-end mt-2">
          <Button
            type="button"
            size="sm"
            variant="primary"
            onClick={addNewItem}
          >
            Add Expenses
          </Button>
        </div>
        <Modal
          show={show}
          size="xl"
          backdrop="static"
          onHide={() => {
            setFilterColumn("all");
            setSearchTerm("");
            handleClose();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Expenses Lists</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    let input = e.target.value;

                    // Remove commas
                    const raw = String(input).replace(/,/g, "");

                    const [intPart, decimalPart] = raw.split(".");

                    // Add commas to integer part
                    const withCommas = intPart.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ",",
                    );

                    // Join back decimal part if it exists
                    const formatted =
                      decimalPart !== undefined
                        ? `${withCommas}.${decimalPart}`
                        : withCommas;

                    if (
                      localExpensesData.find(
                        (item) =>
                          Number(item.totalAmount.toPrecision(17))
                            .toString()
                            .includes(raw) ||
                          item.totalAmount.toFixed(17).includes(raw),
                      )
                    ) {
                      setSearchTerm(formatted);
                    } else {
                      setSearchTerm(raw);
                    }
                  }}
                />
                <Dropdown align="end">
                  <Dropdown.Toggle variant="primary" id="dropdown-search">
                    <i className="fa-solid fa-sliders me-2" />
                    {dropdownFilters.find((opt) => opt.value === filterColumn)
                      ?.label || "Filter"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {dropdownFilters.map(({ value, label }) => (
                      <Dropdown.Item
                        key={value}
                        active={filterColumn === value}
                        onClick={() => setFilterColumn(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </InputGroup>
            </Row>
            <DataTable
              columns={columns}
              data={localExpensesData}
              customStyles={customStyles}
              className="dataTable"
              onRowClicked={(row) =>
                handleIndividualCheckBoxChange(row.transaction_id)
              }
            />
            <PaginationControls {...pagination} />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setFilterColumn("all");
                setSearchTerm("");
                handleClose();
              }}
            >
              Close
            </Button>
            <Button variant="primary" onClick={submitModal}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
      <Container fluid className="mt-4">
        <div className="w-100 d-flex align-items-center mt-3 p-2">
          <h5>Payment</h5>
          <hr className="flex-grow-1 mx-3" />
        </div>
        <div className="w-100 mt-4">
          <Row className="w-100 p-2 mt-1">
            <Col xs={12} md={4} className="p-2">
              <div className="w-100 border shadow-sm p-3 rounded">
                <div className="w-100 d-flex flex-column payment-card border-bottom pb-2 mb-3">
                  <span className="fw-bold">Payment Method</span>
                  {!selected_currency_id && (
                    <small className="text-danger mt-1">
                      Please select a Currency * to continue.
                    </small>
                  )}
                </div>

                <Form validated={validated} onSubmit={handleAddPayment}>
                  <Form.Group className="mb-3" controlId="payWith">
                    <Form.Label className="fw-bold">Pay With:</Form.Label>
                    <div className="d-flex">
                      <Form.Check
                        type="radio"
                        name="paymentType"
                        id="bank"
                        label="Bank"
                        value="Bank"
                        checked={selectedPayment === "Bank"}
                        onChange={handlePaymentMethod}
                        className="me-3"
                        disabled={!selected_currency_id}
                      />
                      <Form.Check
                        type="radio"
                        name="paymentType"
                        id="cash"
                        label="Cash"
                        value="Cash"
                        checked={selectedPayment === "Cash"}
                        onChange={handlePaymentMethod}
                        className="me-3"
                        disabled={!selected_currency_id}
                      />
                    </div>

                    {/* commented muna parang d na now applicable */}
                    {/* <div className="mt-2">
                      <input
                        type="checkbox"
                        checked={onlinePaymentCheckbox}
                        onChange={handleOnlineCheck}
                      />{" "}
                      <label>Online</label>
                    </div> */}
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Step 1 / Subject
                    </Form.Label>
                    <Form.Select
                      className="form-select"
                      onChange={handleSubject1Change}
                      value={subject1}
                      required
                      disabled={!selected_currency_id}
                    >
                      <option value="" selected disabled>
                        Select Subject 1
                      </option>
                      <option value="Account-List">Account-List</option>
                      <option value="Asset Account">Asset Account</option>
                      <option value="Liabilities Account">
                        Liabilities Account
                      </option>
                      <option value="Owner's Equity Account">
                        Owner's Equity Account
                      </option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">
                      Step 2 / Subject
                    </Form.Label>
                    {/* <Form.Select
                      className="form-select"
                      onChange={(e) => {
                        handleSubject2Change(
                          e,
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-subject-type"
                          )
                        );
                      }}
                      onMouseDown={(e) => {
                        if (subject2DataList.length === 0) {
                          e.preventDefault();
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 2 found. Please create a Subject 2 account first.",
                          });
                          return;
                        }
                      }}
                      value={subject2}
                      disabled={isSubject2Disabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 2
                      </option>
                      {subject2DataList.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-subject-type={option.subject_type}
                        >
                          {option.subject_name}
                        </option>
                      ))}
                    </Form.Select> */}
                    <Select
                      disabled={!selected_currency_id}
                      options={subject2Options}
                      value={subject2}
                      onChange={handleSubject2Change}
                      onMenuOpen={() => {
                        if (subject2DataList.length === 0) {
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 2 found. Please create a Subject 2 account first.",
                          });
                          return;
                        }
                      }}
                      menuIsOpen={
                        subject2DataList?.length === 0 ? false : undefined
                      }
                      isDisabled={isSubject2Disabled}
                      placeholder={`Select Subject 2`}
                      styles={selectCustomStyles(subject2, validated)}
                      required
                      isSearchable
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="accountName">
                    <Form.Label className="fw-bold">Accounts</Form.Label>
                    {/* <Form.Select
                      value={subject3}
                      className="p-2"
                      onChange={handleAccountChange}
                      onMouseDown={(e) => {
                        if (subject3DataList.length === 0) {
                          e.preventDefault();
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 3 found. Please create a Subject 3 account first.",
                          });
                          return;
                        }
                      }}
                      required={selectedPayment !== "Online"}
                      disabled={isSubject3Disabled}
                    >
                      <option value="" disabled>
                        Select Account name
                      </option>
                      {subject3DataList.map((data) => (
                        <option key={data.id} value={data.id}>
                          {data.account_name}
                        </option>
                      ))}
                    </Form.Select> */}
                    <Select
                      isDisabled={isSubject3Disabled || !selected_currency_id}
                      options={subject3Options}
                      value={subject3}
                      onChange={handleAccountChange}
                      onMenuOpen={() => {
                        if (subject3DataList.length === 0) {
                          swal({
                            icon: "warning",
                            title: "Warning",
                            text: "No Subject 3 found. Please create a Subject 3 account first.",
                          });
                          return;
                        }
                      }}
                      menuIsOpen={
                        subject3DataList.length === 0 ? false : undefined
                      }
                      placeholder={`Select Account name`}
                      styles={selectCustomStyles(subject3, validated)}
                      required={selectedPayment !== "Online"}
                      isSearchable
                    />
                  </Form.Group>

                  {selectedPayment === "Bank" && !onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="checkNumber">
                      <Form.Label>Cheque #</Form.Label>
                      <Form.Control
                        disabled={!selected_currency_id}
                        type="text"
                        className="p-2"
                        placeholder="000000-000-0000"
                        value={checkNumber}
                        onChange={(e) => {
                          const value = e.target.value;
                          // if (/^[0-9-]*$/.test(value) && value.length <= 15) {
                          //   setCheckNumber(value);
                          // }
                          setCheckNumber(value);
                        }}
                      />
                      <CheckNumberError
                        value={checkNumber}
                        disabled={selectedPayment !== "Bank"}
                        pending={floatPayment
                          .filter((payment) => !payment.isDeleted)
                          .map((payment) => payment.checkNumber)}
                      />
                    </Form.Group>
                  )}

                  {/* {onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="checkNumber">
                      <Form.Label>Reference #</Form.Label>
                      <Form.Control
                        type="text"
                        className="p-2"
                        placeholder="000000-000-0000"
                        value={refNumber}
                        onChange={(e) => setRefNumber(e.target.value)}
                      />
                    </Form.Group>
                  )} */}

                  {/* {onlinePaymentCheckbox && (
                    <Form.Group className="mb-3" controlId="online">
                      <Form.Label>Online Wallet Remarks</Form.Label>
                      <Form.Control
                        type="text"
                        className="p-2"
                        value={onlineWalletRemarks}
                        placeholder="Description"
                        onChange={(e) => setOnlineWalletRemarks(e.target.value)}
                      />
                    </Form.Group>
                  )} */}

                  <Form.Group className="mb-3" controlId="date">
                    <Form.Label>Issue Check Date (Maturity Date)</Form.Label>

                    <CustomDatePicker
                      label={"Date"}
                      selected={date ? new Date(date) : ""}
                      handleDateChange={(date) => {
                        if (!date) {
                          setDate("");
                          return;
                        }
                        const toDateOnly = (d) => {
                          const r = new Date(d);
                          r.setHours(0, 0, 0, 0);
                          return r;
                        };
                        if (
                          payExpensesDate &&
                          toDateOnly(date) < toDateOnly(payExpensesDate)
                        ) {
                          swal({
                            icon: "warning",
                            title: "Invalid Maturity Date",
                            text: "Maturity Date cannot be earlier than the Process Date.",
                            buttons: false,
                            timer: 2500,
                          });
                          return;
                        }
                        setDate(date);
                        setIsAmountDisabled(false);
                        // Replaced by checkCutoffDate (utils/cutoffDateValidation)
                        // dateValidation(date);
                        // postedCutoffValidation(date, setDate, "Date");
                        warnCutoffDate(date, setDate, "Maturity Date");
                      }}
                      setter={setDate}
                      CustomInput={CustomInput}
                      isRequired={true}
                      validated={validated}
                      // "Today" button
                      dateValidation={(today) =>
                        warnCutoffDate(today, setDate, "Maturity Date")
                      }
                      setIsAmountDisabled={setIsAmountDisabled}
                      disabled={
                        !selected_currency_id || selectedPayment === "Cash"
                      }
                      minDate={
                        payExpensesDate
                          ? new Date(
                              new Date(payExpensesDate).setHours(0, 0, 0, 0),
                            )
                          : undefined
                      }
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="amount">
                    <Form.Label>Amount</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>{currencyName}</InputGroup.Text>
                      {/* <Form.Control
                        type="text"
                        className="p-2"
                        required
                        placeholder="0.00"
                        value={amountInputted}
                        onInput={onInputFloat}
                        onChange={(e) => handleAmountValue(e.target.value)}
                        disabled={isAmountDisabled || !selected_currency_id}
                      /> */}
                      <NumberInDecimals
                        className="form-control p-2"
                        required
                        placeholder="0.00"
                        value={amountInputted}
                        decimals={2}
                        onChange={handleAmountValue}
                        disabled={isAmountDisabled || !selected_currency_id}
                      />
                    </InputGroup>
                    {accessType === "Management" && accountName && (
                      <span>
                        Account Balance:{" "}
                        <strong>{formatToTwoDecimal(bankAmount)}</strong>
                      </span>
                    )}
                  </Form.Group>

                  <Button
                    type="submit"
                    variant="primary"
                    className="w-100 p-2"
                    disabled={isAmountDisabled || !selected_currency_id}
                  >
                    Add Payment
                  </Button>
                </Form>
              </div>
            </Col>

            <Col xs={12} md={8} className="p-2 d-flex flex-column">
              <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav variant="tabs">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="paymentList"
                      className="text-dark custom-nav-link"
                    >
                      Payment List
                    </Nav.Link>
                  </Nav.Item>
                  {/* <Nav.Item>
                      <Nav.Link
                        eventKey="AddExpenses"
                        className="text-dark custom-nav-link"
                      >
                        Add Expenses
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link
                        eventKey="DeductionExpenses"
                        className="text-dark custom-nav-link"
                      >
                        Deduction Expenses
                      </Nav.Link>
                    </Nav.Item> */}
                </Nav>

                <Tab.Content className="mt-3">
                  <Tab.Pane eventKey="paymentList">
                    <div className="border p-3 rounded">
                      <h5>Payment List</h5>
                      <Table bordered responsive>
                        <thead>
                          <tr>
                            <th>Type</th>
                            <th>Transaction Number</th>
                            <th>Account Name</th>
                            <th>Amount</th>
                            <th>Check Number</th>
                            <th>Maturity Date</th>
                            {/* <th>Process Date</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        {floatPayment?.length > 0 ? (
                          <tbody>
                            {floatPayment.map((data, i) => (
                              <tr key={i}>
                                <td>{data.paymentMethod || "---"}</td>
                                <td>{data.transactionNumber || "---"}</td>
                                <td>
                                  {data.accountName === ""
                                    ? "---"
                                    : data.accountName}
                                </td>
                                <td>
                                  {formatToTwoDecimal(data.amountInputted)}
                                </td>
                                <td>
                                  {data.checkNumber === ""
                                    ? "---"
                                    : data.checkNumber}
                                </td>
                                <td>
                                  {format(data.issuedDate, "MMM/dd/yyyy")}{" "}
                                  {/* Maturity Date */}
                                </td>
                                {/* <td>
                                    {format(data.processDate, "MMM/dd/yyyy")}
                                  </td> */}
                                {/* <td className="text-primary">Edit</td> */}
                                <td>
                                  <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => deletePayment(data, i)}
                                  >
                                    <i className="fa-solid fa-trash-can"></i>
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        ) : (
                          <caption className="text-center mt-3">
                            There are no records to display
                          </caption>
                        )}
                      </Table>
                    </div>
                  </Tab.Pane>

                  {/* <Tab.Pane eventKey="AddExpenses">
                    <div className="border p-3 rounded">
                      <h5>Additional Expenses</h5>
                      <div className="table-responsive">
                        {renderExpenseTable("additional")}
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm">
                          <Button
                            variant="primary"
                            onClick={() => handleAddRow("additional")}
                            className="w-100"
                            type="button"
                          >
                            Add New List
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="DeductionExpenses">
                    <div className="border p-3 rounded">
                      <h5>Deduction Expenses</h5>
                      <div className="table-responsive">
                        {renderExpenseTable("deduction")}
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm"></div>
                        <div className="col-sm">
                          <Button
                            variant="primary"
                            onClick={() => handleAddRow("deduction")}
                            className="w-100"
                            type="button"
                          >
                            Add New List
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane> */}
                </Tab.Content>
              </Tab.Container>
              <Row className="mt-5">
                <Col sm>
                  <div className="d-flex justify-content-between">
                    <span>Expenses</span>
                    <span className="text-secondary">
                      {formatCurrency(totalAmountSum, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Overall Discount</span>
                    <span
                      className={`${
                        overallDiscount > 0
                          ? "text-danger"
                          : overallDiscount < 0
                            ? "text-success"
                            : "text-secondary"
                      }`}
                    >
                      {formatCurrency(overallDiscount, currencyName)}
                    </span>
                  </div>
                  {/* <div className="d-flex justify-content-between">
                    <span>Additional Expenses</span>
                    <span className="text-secondary">
                      {sumAmounts("additional").toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Deduction Expenses</span>
                    <span className="text-secondary">
                      {sumAmounts("deduction").toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  </div> */}
                  <div className="d-flex justify-content-between">
                    <span>Payments</span>
                    <span className="text-secondary">
                      {formatCurrency(totalPayment, currencyName)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded text-white">
                    <span>Payable Expenses :</span>
                    <span>{formatCurrency(payableExpenses, currencyName)}</span>
                  </div>
                </Col>
                <Col sm></Col>
                <Col sm>
                  <div className="d-flex justify-content-between">
                    <span>Cash</span>
                    <span className="text-secondary">
                      {formatCurrency(totalCashPaid, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Bank</span>
                    <span className="text-secondary">
                      {formatCurrency(totalBankPaid, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Check</span>
                    <span className="text-secondary">
                      {formatCurrency(totalCheckPaid, currencyName)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <label>Online</label>
                    <span className="text-secondary">
                      {formatCurrency(totalOnlinePaid, currencyName)}
                    </span>
                  </div>
                  <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded text-white">
                    <span>Total Payment :</span>
                    <span>
                      <span>{currencyName} &nbsp;</span>
                      {formatCurrency(totalPaymentMethodAmount, currencyName)}
                      {/* {totalCashPaid +
                            totalBankPaid +
                            totalCheckPaid +
                            totalOnlinePaid} */}
                    </span>
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col sm></Col>
                <Col sm></Col>
                <div className="col-sm d-flex flex-row align-items-end mb-2 w-100">
                  {/* <button
                    className="btn btn-outline-secondary w-100 me-3"
                    type="button"
                    onClick={() => {
                      if (foreign_url === "local") {
                        navigate("/accounting/local-expenses");
                      } else {
                        navigate("/accounting/overseas-expenses");
                      }
                    }}
                  >
                    Cancel
                  </button> */}
                  <Button
                    type="button"
                    onClick={handleSavePayment}
                    variant="primary"
                    className="w-100"
                  >
                    Save To
                  </Button>
                </div>
              </Row>
            </Col>
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default LocalBulkExpenses;
